import { render, staticRenderFns } from "./Erasmus.vue?vue&type=template&id=38978bae&"
import script from "./Erasmus.vue?vue&type=script&lang=js&"
export * from "./Erasmus.vue?vue&type=script&lang=js&"
import style0 from "./Erasmus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports